import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { createBrowserHistory } from 'history';
const MASK_STRING = 'Masked by client SDK';
const browserHistory = createBrowserHistory();
const filteringFunction = (envelope) => {
    // Mask IP address and Geolocation data
    Object.assign(envelope, {
        tags: {
            'ai.location.ip': MASK_STRING,
            'ai.location.city': MASK_STRING,
            'ai.location.province': MASK_STRING,
            'ai.location.country': MASK_STRING,
        },
    });
    // filter out other baseType: PageviewData, PageviewPerformanceData, RemoteDependencyData, etc.
    return envelope.baseType === 'EventData';
};
export const reactPlugin = new ReactPlugin();
// *** Add the Click Analytics plug-in. ***
/* var clickPluginInstance = new ClickAnalyticsPlugin();
   var clickPluginConfig = {
     autoCapture: true
}; */
export const appInsights = new ApplicationInsights({
    config: {
        connectionString: process.env.APP_INSIGHTS_CONN_STR,
        // *** If you're adding the Click Analytics plug-in, delete the next line. ***
        extensions: [reactPlugin],
        // *** Add the Click Analytics plug-in. ***
        // extensions: [reactPlugin, clickPluginInstance],
        extensionConfig: {
            [reactPlugin.identifier]: { history: browserHistory },
            // *** Add the Click Analytics plug-in. ***
            // [clickPluginInstance.identifier]: clickPluginConfig
        },
    },
});
appInsights.loadAppInsights();
appInsights.addTelemetryInitializer(filteringFunction);
